<template>
    <div class="tree-list" v-if="isInit">
        <el-form ref="form" :model="field" :label-width="field.name ? '120px' : '0'">
            <el-form-item
                class="input-row"
                :label="field.desc"
                prop="def_val">
                <div v-if="field.name" slot="label" class="label-item common">
                    <p class="label-text">{{ field.desc }}</p>
                    <el-tooltip class="item" effect="light" placement="bottom-start">
                        <div slot="content">
                            - name: <strong>{{ field.name }}</strong><br/>
                        </div>
                        <i class="label-icon el-icon-info"></i>
                    </el-tooltip>
                </div>
                <div class="tree-block">
                    <el-button size="mini" icon="el-icon-plus" @click="appendNode">新建顶级节点</el-button>
                    <el-tree
                        :data="field.def_val"
                        node-key="id"
                        default-expand-all
                        :expand-on-click-node="false"
                        :render-content="renderContent">
                    </el-tree>
                </div>
            </el-form-item>
        </el-form>
    </div>
</template>
<script>
import moment from 'moment';

export default {
    name: 'tree-list',
    props: ['field', 'autoInit'],
    data() {
        return {
            // resField: this.field,
            fieldRules: {
                required: this.field.require,
                message: `请填写'${this.field.desc}'的内容`,
                trigger: 'blur'
            },
            isInit: this.autoInit
            // fieldRules: {
            //     required: true,
            //     message: '12sddfasdf',
            //     trigger: 'blur'
            // }
        }
    },
    components: {
    },
    watch: {
    },
    methods: {
        initData() {
            this.isInit = true;
        },
        appendNode(data = {}) {
            this.$prompt('请输入内容', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                closeOnClickModal: false,
                inputPattern: /\S{1,}/,
                inputType: 'textarea',
                inputErrorMessage: '内容格式不正确'
            }).then(({ value }) => {
                const newChild = { id: new Date().getTime(), label: value, children: [] };
                if (data.id) {
                    if (!data.children) {
                      this.$set(data, 'children', []);
                    }
                    data.children.push(newChild);
                } else {
                    this.field.def_val.push(newChild);
                }
            }).catch(() => {
            });

        },
        editNode(node, data) {
            this.$prompt('请输入内容', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                closeOnClickModal: false,
                inputValue: data.label,
                inputPattern: /\S{1,}/,
                inputType: 'textarea',
                inputErrorMessage: '内容格式不正确'
            }).then(({ value }) => {
                const parent = node.parent;
                const children = parent.data.children || parent.data;
                const index = children.findIndex(d => d.id === data.id);
                children[index].label = value;
            }).catch(() => {
            });
        },
        removeNode(node, data) {
            const parent = node.parent;
            const children = parent.data.children || parent.data;
            const index = children.findIndex(d => d.id === data.id);
            children.splice(index, 1);
        },
        renderContent(h, { node, data, store }) {
            return (
                <span class="custom-tree-node">
                    <p class="node-text" title={node.label}>{node.label}</p>
                    <span class="control-btns">
                        <i class="el-icon el-icon-circle-plus large" on-click={ () => this.appendNode(data) } title="新增子节点">
                        </i>
                        {
                            data.id &&
                            <i class="el-icon el-icon-edit large" on-click={ () => this.editNode(node, data) } title="编辑">
                            </i>
                        }
                        {
                            data.id &&
                            <i class="el-icon el-icon-delete large" on-click={ () => this.removeNode(node, data) } title="删除">
                            </i>
                        }
                    </span>
                </span>
            );
        },
        fieldBeReady() {
            // 确认组件是否就绪
            return this.$refs['form'];
        },
        getResField() {
            let isValidate = false;
            this.$refs['form'].validate((valid) => {
                if (valid) {
                    isValidate = true;
                } else {
                    isValidate = false;
                }
            });
            if (!isValidate) {
                return;
            }
            return this.field;
        }
    },
    computed: {
    },
    mounted() {
    }
}
</script>
<style lang="less">
    @import (reference) '../../styles/public.less';
    .tree-list {
        .label-item();
        .tree-block {
            background-color: #fff;
            padding: 5px 10px;
        }
        .custom-tree-node {
            max-width: 100%;
            .flexbox();
            .align-items(center);
            .justify-content(flex-start);
            font-size: 14px;
            padding-right: 8px;
            .node-text {
                max-width: 80%;
                overflow: hidden; 
                text-overflow: ellipsis; 
                // display: -webkit-box; 
                // -webkit-line-clamp: 1; 
                // -webkit-box-orient: vertical;
            }
            .control-btns {
                margin-left: 20px;
                i[class^="el-icon"] {
                    cursor: pointer;
                    color: #20a0ff;
                    margin-right: 5px;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/compEditForm/treeList.vue